<template>
  <div class="user-complaints">
    <van-tabs v-model="active">
      <van-tab v-for="(complaint, index) in data" :title="complaint.complaintName" :key="complaint.id">
        <van-form :ref="'form' + index" @submit="onSubmit" @failed="onFailed">
          <template v-for="item in complaint.items">
            <!-- 单行文本输入 -->
            <template v-if="item.type === 1">
              <van-field
                v-model="item.content"
                :name="'type' + item.index"
                :label="item.title"
                :placeholder="item.placeholder"
                :rules="[{ validator: validateInput, message: '请输入' + item.title }]"
                :key="item.index"
              >
                <!-- 自定义label -->
                <template #label>
                  <p class="custom-label" v-html="getComputedTitile(item.title)"></p>
                </template>
              </van-field>
            </template>
            <!-- 多行文本输入 -->
            <template v-else-if="item.type === 2">
              <van-field :label="item.title" :placeholder="item.placeholder" class="custom-flex" :key="item.index">
                <template #input>
                  <van-field
                    v-model="item.content"
                    :name="'type' + item.index"
                    class="clear-padding"
                    rows="3"
                    autosize
                    label=""
                    type="textarea"
                    :maxlength="item.limit"
                    :placeholder="item.placeholder"
                    :rules="[{ validator: validateInput, message: '请输入' + item.title }]"
                    show-word-limit
                  />
                </template>
                <!-- 自定义label -->
                <template #label>
                  <p class="custom-label" v-html="getComputedTitile(item.title)"></p>
                </template>
              </van-field>
            </template>
            <!-- 数字输入 -->
            <template v-else-if="item.type === 3">
              <van-field
                v-model="item.content"
                type="number"
                :name="'type' + item.index"
                :label="item.title"
                :placeholder="item.placeholder"
                :rules="[{ validator: validatePhone, message: '请输入' + item.title, row: item }]"
                :key="item.index"
              >
                <!-- 自定义label -->
                <template #label>
                  <p class="custom-label" v-html="getComputedTitile(item.title)"></p>
                </template>
              </van-field>
            </template>
            <!-- 单选、多选 -->
            <template v-else-if="item.type === 4 || item.type === 5">
              <van-field
                :name="'type' + item.index"
                v-model="item.content"
                readonly
                clickable
                arrow-direction="down"
                :label="item.title"
                :placeholder="item.placeholder"
                :rules="[{ required: true, message: '请选择' + item.title }]"
                @click="getSelector(item)"
                :key="item.index"
              >
                <!-- 自定义label -->
                <template #label>
                  <p class="custom-label" v-html="getComputedTitile(item.title)"></p>
                </template>
                <!-- 自定义向下图标 -->
                <template #right-icon>
                  <van-icon name="arrow-down" />
                </template>
              </van-field>
            </template>
            <!-- 日期 -->
            <template v-else-if="item.type === 6">
              <!-- 日期 -->
              <van-field
                :name="'type' + item.index"
                :value="getComputedDate(item.content)"
                label="日期"
                readonly
                clickable
                :placeholder="item.placeholder"
                :rules="[{ required: true, message: '请选择' + item.title }]"
                @click="getDate(item)"
                :key="item.index"
              >
                <!-- 自定义label -->
                <template #label>
                  <p class="custom-label" v-html="getComputedTitile(item.title)"></p>
                </template>
                <!-- 自定义向下图标 -->
                <template #right-icon>
                  <van-icon name="arrow-down" />
                </template>
              </van-field>
            </template>
          </template>
        </van-form>
      </van-tab>
    </van-tabs>
    <!-- 下拉单选 -->
    <van-popup v-model="single.show" position="bottom" :close-on-click-overlay="false">
      <van-radio-group v-model="single.checked">
        <van-cell-group>
          <van-cell v-for="(item, index) in single.data" :key="item" :title="item" clickable @click="singleToggle(index, item)">
            <template #right-icon>
              <van-radio :name="index" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-button type="primary" class="save" @click="closePop(single)">保存</van-button>
    </van-popup>
    <!-- 下拉多选 -->
    <van-popup v-model="multiple.show" position="bottom" :close-on-click-overlay="false">
      <van-checkbox-group v-model="multiple.checked">
        <van-cell-group>
          <van-cell v-for="(item, index) in multiple.data" clickable :key="item" :title="item" @click="multipleToggle(index, item)">
            <template #right-icon>
              <van-checkbox :name="item" ref="checkboxes" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <van-button type="primary" class="save" @click="closePop(multiple)">保存</van-button>
    </van-popup>
    <!-- 日期选择 -->
    <van-calendar
      v-model="calendar.show"
      :close-on-click-overlay="false"
      :type="calendar.type"
      :default-date="calendar.defaultDate"
      :min-date="calendar.minDate"
      :max-date="calendar.maxDate"
      :allow-same-day="true"
      :lazy-render="false"
      @close="onConfirmDate"
      ref="calendar"
    >
      <template #title>
        {{ '日期选择' }}
      </template>
      <template #footer>
        <van-button type="primary" @click="closeCalendar" round>确定</van-button>
      </template>
    </van-calendar>
    <!-- 提交订单按钮 -->
    <van-button class="list-block-margin" type="primary" block @click="triggerSubmit">提交</van-button>
    <!-- 成功弹窗 -->
    <van-dialog v-model="success.show" title="" show-confirm-button @confirm="closeWindow">
      <van-icon name="passed" />
      <p>提交成功</p>
    </van-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import axios from 'axios'

  /**
   * todo 递归 清理赋值
   */
  const clearValues = (data) => {
    data.forEach((item) => {
      if (item.items && item.items.length) {
        clearValues(item.items)
      }
      if (Object.hasOwnProperty.call(item, 'content')) {
        item.content = ''
      }
    })
  }

  export default {
    data() {
      return {
        active: 0,
        activeOld: 0,
        activeNames: [],
        // 单选弹窗
        single: {
          show: false,
          checked: undefined,
          data: []
        },
        // 多选弹窗
        multiple: {
          show: false,
          checked: [],
          data: []
        },
        // 日期 or 日历
        calendar: {
          show: false,
          type: 'single',
          minDate: moment().toDate(),
          maxDate: moment().toDate(),
          defaultDate: null
        },
        success: {
          show: false
        },
        formData: {},
        showCalendar: false,
        data: [],
        index: 0,
        source: null,
        limitSubmit: false
      }
    },
    created() {
      this.$api.userComplaints.getTempletList().then((res) => {
        let { result } = res
        if (result && Array.isArray(result)) {
          this.data = result
        }
      })
    },
    computed: {
      /**
       * todo 动态计算title个数，左右对齐
       */
      getComputedTitile() {
        return (t) => {
          let arr = t.split('')
          let res = ''

          // 动态计算8位以内的数字两端对齐
          switch (arr.length) {
            case 2:
              res = `${arr[0]}<strong class="two">${arr[1]}</strong>`
              break
            case 3:
              res = `${arr[0]}<strong class="three">${arr[1]}</strong><strong class="three">${arr[2]}</strong>`
              break
            // case 6:
            //   res = `${arr.splice(0, 5).join('')}<strong class="two">${arr[arr.length - 1]}</strong>`
            //   break
            // case 7:
            //   res = `${arr.splice(0, 5).join('')}<strong class="three">${arr[arr.length - 2]}</strong><strong class="three">${arr[arr.length - 1]}</strong>`
            //   break

            default:
              res = arr.join('')
              break
          }

          return res
        }
      },
      /**
       * todo 转换日期范围显示的范围
       */
      getComputedDate() {
        return (v) => {
          return v.replace(/,/gi, ' ~ ')
        }
      }
    },
    watch: {
      'multiple.checked'(newValue, oldValue) {
        let setItem = this.data[this.active].items.find((item) => item.index === this.index)
        setItem.content = newValue.join(',')
      },
      active(newValue) {
        this.$refs['form' + this.activeOld][0].resetValidation()
        clearValues(this.data)
        this.activeOld = newValue
      }
    },
    methods: {
      moment,
      /**
       * todo 单选、多选关闭弹窗
       */
      closePop(ele) {
        ele.show = false
      },
      /**
       * todo 获取日期弹窗
       */
      getDate({ beginDate, index, endDate, dayType, content }) {
        this.index = index
        /**
         * todo 判断回显值方法
         */
        const setContent = (content, dayType, endDate) => {
          let resContent = undefined
          // 范围
          if (dayType === -1) {
            resContent = content ? content.split(',').map((date) => moment(date).toDate()) : endDate === '1' ? [moment().toDate()] : moment(endDate).toDate()
            // 单选
          } else {
            resContent = content ? moment(content).toDate() : endDate === '1' ? moment().toDate() : moment(endDate).toDate()
          }
          return resContent
        }
        setTimeout(() => {
          // 打开弹窗
          this.calendar.show = true
          // 日历弹出配置信息
          this.calendar = {
            ...this.calendar,
            minDate: moment(beginDate).toDate(),
            maxDate: endDate === '1' ? moment().toDate() : moment(endDate).toDate(),
            type: dayType === -1 ? 'range' : 'single',
            defaultDate: setContent(content, dayType, endDate)
          }
          this.$forceUpdate()
        }, 50)
      },
      /**
       * todo 获取下拉
       */
      getSelector({ content, type, index, radioTitles, checkboxTitles }) {
        this.index = index
        // 单选
        if (type === 4) {
          this.single = {
            ...this.single,
            show: true,
            data: radioTitles,
            checked: content //回显塞值
          }
          // 多选
        } else if (type === 5) {
          this.multiple = {
            ...this.multiple,
            show: true,
            data: checkboxTitles,
            checked: content ? content.split(',') : [] //回显塞值
          }
        }
      },
      /**
       * todo 单选切换
       */
      singleToggle(index, item) {
        this.single.checked = index
        let setItem = this.data[this.active].items.find((item) => item.index === this.index)
        setItem.content = item
      },
      /**
       * todo 多选切换
       */
      multipleToggle(index, item) {
        this.$refs.checkboxes[index].toggle()
      },
      /**
       * todo 自定义提交
       */
      triggerSubmit() {
        this.$refs[`form${this.active}`][0].submit()
      },
      onFailed(e) {},
      /**
       * todo 提交表单
       */
      onSubmit(v) {
        if (this.limitSubmit) {
          return
        }
        this.limitSubmit = true
        this.$api.userComplaints.subComplaint(this.data[this.active]).then((res) => {
          this.limitSubmit = false
          let { status } = res
          if (status) {
            this.success.show = true
          }
        })
      },
      /**
       * todo 关闭日历弹窗
       */
      closeCalendar() {
        this.calendar.show = false
      },
      /**
       * todo 日期日历选择
       */
      onConfirmDate() {
        let v = this.$refs.calendar.currentDate
        if (Array.isArray(v) && !v[1]) {
          v[1] = v[0]
        }
        let setItem = this.data[this.active].items.find((item) => item.index === this.index)
        setItem.content = Array.isArray(v) ? v.map((item) => moment(item).format('YYYY-MM-DD')).join(',') : moment(v).format('YYYY-MM-DD')
      },
      /**
       * todo 自定义敏感词校验规则
       */
      validateInput(value, rule) {
        if (!value) {
          return false
        }
        // if (this.source) {
        //   this.source.cancel('取消查询！')
        // }
        return new Promise((resolve, reject) => {
          let params = {
            contentStr: value
          }
          let cancelToken = axios.CancelToken
          this.source = cancelToken.source()
          this.$api.userComplaints.checkSensitiveWords(params, { cancelToken: this.source.token }).then((res) => {
            let { count, result } = res
            if (count > 0) {
              resolve(true)
            } else {
              rule.message = result
              resolve(false, rule)
            }
          })
        })
      },
      /**
       * todo 自定义手机号码校验规则
       */
      validatePhone(value, rule) {
        if (!value) {
          return false
        }
        // 只有isPhone为true的时候，才校验手机号
        if (!rule.row.isPhone) {
          return
        }
        return new Promise((resolve, reject) => {
          if (/^\d{11}$/gi.test(value)) {
            resolve(true)
          } else {
            rule.message = '请输入正确的手机号'
            resolve(false, rule)
          }
        })
      },
      /**
       * todo 成功确认关闭
       */
      closeWindow() {
        window.location.href = 'about:blank'
        window.wx.closeWindow()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .user-complaints {
    .van-cell {
      align-items: flex-start;
      &.clear-padding {
        padding: 0;
      }
      &.custom-flex {
        align-items: flex-start;
      }
      /deep/ .van-field__label {
        width: 4rem;
      }
      .custom-label {
        margin: 0;
        /deep/ strong {
          font-weight: normal;
          &.two {
            margin-left: 1.7rem;
          }
          &.three {
            margin-left: 0.4rem;
          }
        }
        span {
          margin-left: 1.7rem;
        }
      }
    }
    .list-block-margin {
      margin: 10px auto;
      width: 90%;
    }
    .van-popup {
      padding-bottom: 1rem;
      .van-button.save {
        display: block;
        font-size: 0.8rem;
        padding: 0.9rem !important;
        width: 92%;
        margin: 1rem auto 0;
        height: auto;
        line-height: 0.5;
      }
      .van-cell-group {
        padding-top: 1rem;
      }
      /deep/ .van-calendar__footer {
        text-align: center;
        .van-button {
          width: 90%;
          background-color: #ee0a24 !important;
        }
      }
    }
    .van-dialog {
      /deep/ .van-dialog__content {
        height: auto;
        padding: 2rem 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: flex-start;
        .van-icon {
          font-size: 4rem;
          color: #07c160;
          line-height: normal;
        }
        p {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
</style>
